import { times } from "lodash";
import moment from "moment";

export const PATIENT_ROLE = "patient";
export const PANEL = "patient";
export const DOCTOR_FEES = 25;
export const DOCTOR_TIME_DURATION = 30;

export const APP_VERSION_MISMATCH = "APP version mismatch";

export const HOURS = times(24).map(hour => {
  return {
    text: moment()
      .set({ hour: hour, minute: 0, second: 0, millisecond: 0 })
      .format("hh a"),
    value: hour
  };
});

export const MINUTES = times(60).map(minute => {
  return {
    text: minute,
    value: minute
  };
});

export const TERPENE_CHART_COLORS = [
  "#8EA3C0",
  "#737F8B",
  "#5B6370",
  "#D9D0C7",
  "#F2F2F2",
  "#717580",
  "#94B4FF",
  "#E2EAFF",
  "#4B5A81",
  "#B4BBCD",
  "#A2B7CC",
  "#87A0C8",
  "#6382B0",
  "#506791",
  "#2D4464",
  "#96B1CC",
  "#CEE1F2",
  "#362E2B",
  "#787677",
  "#736562",
  "#6695BF",
  "#3C5A72"
];
